import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import NavBar from "../../components/navbar/navbar";
import { ChildContainer, PagesBox } from "./styles";
import CampaignIcon from "@mui/icons-material/Campaign";
import StorefrontIcon from "@mui/icons-material/Storefront";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CollectionsIcon from '@mui/icons-material/Collections';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FolderSharedSharpIcon from '@mui/icons-material/FolderSharedSharp';
import BadgeSharpIcon from '@mui/icons-material/BadgeSharp';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PreviewIcon from '@mui/icons-material/Preview';
import ReorderIcon from '@mui/icons-material/Reorder';
import { useLocation, useNavigate } from "react-router-dom";
import { sentActionLog, verify } from "../../utils/common";


const Admin: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  
  React.useEffect(() => {
    (async () => {
      if (!["/", "/login"].includes(location.pathname)) {
        const currentToken = localStorage.getItem("jwt");
        if (currentToken) {
          const isValid = await verify(currentToken);
          if (!isValid) {
            navigate("/");
          } else {
            const permissions = JSON.parse(localStorage.getItem("user") || '{}')
            if(!permissions?.administrationAccess){
                navigate("/Home");
            }
          }
        } else {
          navigate("/");
        }
      }
    })();
  }, [location.pathname, navigate]);

  React.useEffect(() => {
    sentActionLog('Visit_Admin', 'Entro en la vista Admin');
  }, [])

  return (
    <Box width={"100%"} mb={10}>
      <NavBar />
      <PagesBox theme={theme}>
        <ChildContainer theme={theme} onClick={() => navigate("/offers")}>
          <CampaignIcon />
          <Typography variant="h6">Ofertas</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/squares")}>
          <StorefrontIcon />
          <Typography variant="h6">Plazas</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/catalogs")}>
          <FormatListBulletedIcon />
          <Typography variant="h6">Catalogos</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/banners")}>
          <CollectionsIcon />
          <Typography variant="h6">Banners</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/statistics")}>
          <AssessmentIcon />
          <Typography variant="h6">Reportes</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/notifications")}>
          <CircleNotificationsIcon />
          <Typography variant="h6">Notificaciones</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/carrusel")}>
          <CollectionsIcon />
          <Typography variant="h6">Carrusel</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/material")}>
          <CollectionsIcon />
          <Typography variant="h6">Material de Apoyo</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/admin-cms")}>
          <ViewCarouselIcon />
          <Typography variant="h6">Admin CMS</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/admin-cms-reorden")}>
          <ReorderIcon />
          <Typography variant="h6">Reordenar Carrusel</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/cms-demo")}>
          <PreviewIcon />
          <Typography variant="h6">Demo CMS</Typography>
        </ChildContainer>
        <ChildContainer theme={theme} onClick={() => navigate("/admin-user")}>{/*nueva ruta a crear admin user*/}
          <FolderSharedSharpIcon />
          <Typography variant="h6">Admin User</Typography>
        </ChildContainer>
      </PagesBox>
    </Box>
  );
};

export default Admin;
